import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FlaskConical } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useDemo, MODULE_ROUTES } from "@/lib/demo";

const left = (ms) => { if (ms <= 0) return "expired"; const h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000); return h >= 1 ? `${h}h ${m}m left` : `${m}m left`; };

export const DemoBanner = () => {
  const { user } = useAuth();
  const on = user?.role === "demo";
  const d = useDemo(on);
  const { pathname } = useLocation();
  const [now, setNow] = useState(Date.now());
  useEffect(() => { if (!on) return undefined; const t = setInterval(() => setNow(Date.now()), 30000); return () => clearInterval(t); }, [on]);
  const exp = d ? new Date(d.expires_at) - (now + d.offset) : 1;
  useEffect(() => { if (on && d && exp <= 0) api.get("/api/demos/me").catch(() => window.location.assign("/demo-expired")); }, [on, d, exp]);
  useEffect(() => { if (!on || !d) return; const m = Object.entries(MODULE_ROUTES).find(([k, r]) => d.modules.includes(k) && pathname.startsWith(r)); if (m) api.post("/api/demos/me/track", { module: m[0] }).catch(() => {}); }, [on, d, pathname]);
  if (!on || !d) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[65] bg-amber-400 text-slate-900 text-xs sm:text-sm font-bold px-4 py-2 flex flex-wrap items-center gap-x-3 gap-y-1 justify-center shadow-[0_-4px_20px_rgba(0,0,0,0.15)]" data-testid="demo-banner">
      <span className="flex items-center gap-1 tracking-widest"><FlaskConical className="w-4 h-4" />DEMO ENVIRONMENT</span><span className="font-semibold">Sample data only · nothing is charged or sent to real customers</span>
      <span data-testid="demo-banner-expires">Ends {new Date(d.expires_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })} ({left(exp)})</span>
      <Link to="/demo/app" className="underline" data-testid="demo-banner-home">Demo home</Link><Link to="/pricing" className="h-7 px-3 leading-7 rounded-full bg-slate-900 text-white" data-testid="demo-banner-subscribe">Activate subscription</Link>
    </div>
  );
};
